const readFileAsDataURL = (file: File) => {
  const reader = new FileReader()

  return new Promise((resolve) => {
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.readAsDataURL(file)
  })
}

export default readFileAsDataURL
